/* Home v2 generative visuals. Canvas 2D only, no libraries. Each drawing pauses when off screen,
   runs at ~30 fps, and renders a single still frame under prefers-reduced-motion. */
(function () {
  'use strict';
  if (window.__h2) return; window.__h2 = true;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const css = (el, v) => getComputedStyle(el).getPropertyValue(v).trim();
  const MODS = ['--rr-trauma', '--rr-rescue', '--rr-cover', '--rr-forge', '--rr-protect'];

  /* ---------- tiny 3D helpers ---------- */
  function project(p, W, H, yaw, pitch, dist, scale, cx) {
    const cy = Math.cos(yaw), sy = Math.sin(yaw), cp = Math.cos(pitch), sp = Math.sin(pitch);
    let x = p[0] * cy - p[2] * sy, z = p[0] * sy + p[2] * cy, y = p[1];
    const y2 = y * cp - z * sp; z = y * sp + z * cp; y = y2;
    const f = dist / (dist + z);
    return [W * (cx == null ? .5 : cx) + x * f * scale, H / 2 + y * f * scale, f];
  }
  /* panel geometry in a 100 × 158 unit space, centered */
  function panelPoints() {
    const W = 100, H = 158, c = 9, r = 4, pts = [];
    const edge = (a, b, n, k) => { for (let i = 0; i <= n; i++) { const t = i / n; pts.push([a[0] + (b[0] - a[0]) * t, a[1] + (b[1] - a[1]) * t, 0, k]); } };
    const P = [[-W/2 + r, -H/2], [W/2 - c, -H/2], [W/2, -H/2 + c], [W/2, H/2 - r], [W/2 - r, H/2], [-W/2 + r, H/2], [-W/2, H/2 - r], [-W/2, -H/2 + r]];
    for (let i = 0; i < P.length; i++) { const a = P[i], b = P[(i + 1) % P.length]; edge(a, b, Math.round(Math.hypot(b[0] - a[0], b[1] - a[1]) / 2.2), 'edge'); }
    const cols = 5, rows = 9, sw = (W - 16) / cols, sh = (H - 20) / rows;
    for (let rr = 0; rr < rows; rr++) for (let cc = 0; cc < cols; cc++) {
      const x = -W/2 + 8 + cc * sw + sw * .18, y = -H/2 + 10 + rr * sh + sh * .28, w = sw * .64, h = sh * .44;
      edge([x, y], [x + w, y], 6, 'slot'); edge([x + w, y], [x + w, y + h], 4, 'slot'); edge([x + w, y + h], [x, y + h], 6, 'slot'); edge([x, y + h], [x, y], 4, 'slot');
    }
    return pts;
  }
  const PANEL = panelPoints();
  function drawPanel(c, W, H, t, opts) {
    const el = opts.el, fg = css(el, '--rr-fg'), mute = css(el, '--rr-mute');
    const yaw = opts.static ? -.35 : Math.sin(t / 5200) * .42, pitch = opts.static ? .16 : .16 + Math.sin(t / 7300) * .05;
    const scale = opts.scale, dist = 420;
    // module slabs (behind points): five slabs mounted on the panel face, slightly proud (z = -3)
    const slabs = opts.slabs == null ? 5 : opts.slabs;
    for (let i = 0; i < slabs; i++) {
      const y0 = -79 + 10 + i * 27, h = 22, x0 = -42, w = 84;
      const q = [[x0, y0, -3], [x0 + w, y0, -3], [x0 + w, y0 + h, -3], [x0, y0 + h, -3]].map(p => project(p, W, H, yaw, pitch, dist, scale, opts.cx));
      c.beginPath(); q.forEach((p, k) => k ? c.lineTo(p[0], p[1]) : c.moveTo(p[0], p[1])); c.closePath();
      c.fillStyle = css(el, MODS[i]); c.globalAlpha = .82; c.fill(); c.globalAlpha = 1;
    }
    // point cloud
    for (const p of PANEL) {
      const [x, y, f] = project(p, W, H, yaw, pitch, dist, scale, opts.cx);
      c.fillStyle = p[3] === 'edge' ? fg : mute; c.globalAlpha = p[3] === 'edge' ? .9 * f : .55 * f;
      const s = (p[3] === 'edge' ? 1.6 : 1.2) * f; c.fillRect(x, y, s, s);
    }
    c.globalAlpha = 1;
  }

  /* ---------- canvas runner ---------- */
  function run(canvas, draw) {
    let visible = false, last = 0, dpr = devicePixelRatio || 1;
    function frame(t) {
      if (visible && t - last > 33) { last = t; paint(t); }
      if (!reduced) requestAnimationFrame(frame);
    }
    function paint(t) {
      const r = canvas.getBoundingClientRect(); if (!r.width) return;
      if (canvas.width !== Math.round(r.width * dpr)) { canvas.width = Math.round(r.width * dpr); canvas.height = Math.round(r.height * dpr); }
      const c = canvas.getContext('2d'); c.setTransform(dpr, 0, 0, dpr, 0, 0); c.clearRect(0, 0, r.width, r.height);
      draw(c, r.width, r.height, t);
    }
    new IntersectionObserver(([e]) => { visible = e.isIntersecting; if (visible) paint(performance.now()); }).observe(canvas);
    if (!reduced) requestAnimationFrame(frame);
    addEventListener('resize', () => paint(performance.now()));
  }

  /* hero: the lead + buy row is as wide as the headline, so the button's right edge sits on the headline's rail */
  document.querySelectorAll('.h2-hero').forEach(h => {
    const h1 = h.querySelector('h1'), inner = h.querySelector('.inner'); if (!h1 || !inner) return;
    const range = document.createRange();
    const measure = () => { range.selectNodeContents(h1); const w = Math.ceil(range.getBoundingClientRect().width); if (w) inner.style.setProperty('--h1w', w + 'px'); };
    measure(); if ('ResizeObserver' in window) new ResizeObserver(measure).observe(h1); addEventListener('load', measure);
  });
  /* hero: orbiting panel with five modules */
  document.querySelectorAll('[data-h2-hero]').forEach(cv => {
    const el = cv.closest('.rr');
    run(cv, (c, W, H, t) => drawPanel(c, W, H, t, { el, scale: W > 860 ? Math.min(W / 300, H / 210) : Math.min(W / 190, H / 230), static: reduced, cx: W > 860 ? .7 : .5 }));
  });
  /* lineup tiles */
  document.querySelectorAll('[data-h2-core]').forEach(cv => {
    const el = cv.closest('.rr');
    run(cv, (c, W, H, t) => drawPanel(c, W, H, t, { el, scale: Math.min(W / 190, H / 190), static: true, slabs: 3 }));
  });
  document.querySelectorAll('[data-h2-packs]').forEach(cv => {
    const el = cv.closest('.rr');
    run(cv, (c, W, H, t) => {
      const fg = css(el, '--rr-fg'), mute = css(el, '--rr-mute'); const sizes = [.62, .78, .92], names = ['--rr-hydra', '--rr-sentry', '--rr-fury'];
      const base = Math.min(W / 3.6, H / 1.35);
      sizes.forEach((s, i) => {
        const w = base * s * .78, h = base * s, x = W / 2 + (i - 1) * base * .95 - w / 2, y = H * .82 - h;
        c.strokeStyle = fg; c.globalAlpha = .85; c.lineWidth = 1.2; c.setLineDash([2, 4]);
        c.beginPath(); c.roundRect(x, y, w, h, [h * .08, h * .08, h * .05, h * .05]); c.stroke();
        c.setLineDash([]); c.globalAlpha = .5; c.strokeStyle = mute; c.strokeRect(x + w * .22, y + h * .12, w * .56, h * .7);
        c.globalAlpha = 1; c.fillStyle = css(el, names[i]); c.fillRect(x + w * .5 - 3, y - 9, 6, 6);
      });
      c.globalAlpha = 1;
    });
  });
  document.querySelectorAll('[data-h2-modules]').forEach(cv => {
    const el = cv.closest('.rr');
    run(cv, (c, W, H, t) => {
      const n = 5, w = Math.min(W * .62, 240), h = w * .3, gap = h * .28, x = (W - w) / 2, y0 = (H - (n * h + (n - 1) * gap)) / 2;
      for (let i = 0; i < n; i++) {
        const y = y0 + i * (h + gap), ch = w * .06;
        c.beginPath(); c.moveTo(x, y); c.lineTo(x + w - ch, y); c.lineTo(x + w, y + ch); c.lineTo(x + w, y + h); c.lineTo(x, y + h); c.closePath();
        c.fillStyle = css(el, MODS[i]); c.fill();
      }
    });
  });
  /* single hovering pack (one per tile): dotted wireframe, gentle bob, soft shadow */
  document.querySelectorAll('[data-h2-pack]').forEach(cv => {
    const el = cv.closest('.rr'), i = +cv.dataset.h2Pack || 0, view = +cv.dataset.h2View || 0, names = ['--rr-hydra', '--rr-sentry', '--rr-fury'], sizes = [.72, .84, .96];
    run(cv, (c, W, H, t) => {
      const fg = css(el, '--rr-fg'), mute = css(el, '--rr-mute');
      const bob = reduced ? 0 : Math.sin(t / 1800 + i) * H * .012, tilt = (reduced ? 0 : Math.sin(t / 2600 + i) * .04) + [0, -.18, .22, -.06][view % 4];
      const h = Math.min(H * .62, W * .9) * sizes[i], w = h * .74, cx = W / 2, cy = H * .52 + bob;
      // shadow
      c.fillStyle = fg; c.globalAlpha = .06; c.beginPath(); c.ellipse(cx, H * .86, w * .42, h * .05, 0, 0, Math.PI * 2); c.fill();
      c.save(); c.translate(cx, cy); c.rotate(tilt); c.translate(-cx, -cy);
      const x = cx - w / 2, y = cy - h / 2;
      const dots = (fn, n) => { for (let k = 0; k <= n; k++) { const [px, py] = fn(k / n); c.fillRect(px, py, 1.4, 1.4); } };
      c.fillStyle = fg; c.globalAlpha = .85;
      // body outline (rounded top, chamfered bottom)
      const r = h * .12;
      dots(u => [x + r + (w - 2 * r) * u, y], 60); dots(u => [x + w, y + r + (h - 2 * r) * u], 80); dots(u => [x + w - r - (w - 2 * r) * u, y + h], 60); dots(u => [x, y + h - r - (h - 2 * r) * u], 80);
      for (let a = 0; a < 4; a++) { const cxr = [x + r, x + w - r, x + w - r, x + r][a], cyr = [y + r, y + r, y + h - r, y + h - r][a], a0 = [Math.PI, 1.5 * Math.PI, 0, .5 * Math.PI][a]; dots(u => [cxr + r * Math.cos(a0 + u * Math.PI / 2), cyr + r * Math.sin(a0 + u * Math.PI / 2)], 14); }
      // lid seam + panel window + straps
      c.globalAlpha = .45; c.fillStyle = mute;
      dots(u => [x + w * .1 + w * .8 * u, y + h * .22], 40);
      const px0 = x + w * .22, py0 = y + h * .3, pw = w * .56, ph = h * .5;
      dots(u => [px0 + pw * u, py0], 30); dots(u => [px0 + pw, py0 + ph * u], 40); dots(u => [px0 + pw - pw * u, py0 + ph], 30); dots(u => [px0, py0 + ph - ph * u], 40);
      for (let rr = 0; rr < 4; rr++) for (let cc = 0; cc < 3; cc++) { const sx = px0 + pw * .1 + cc * pw * .28, sy = py0 + ph * .1 + rr * ph * .22; c.fillRect(sx, sy, pw * .2, 1); c.fillRect(sx, sy + ph * .1, pw * .2, 1); }
      dots(u => [x + w * .08, y + h * .35 + h * .5 * u], 30); dots(u => [x + w * .92, y + h * .35 + h * .5 * u], 30);
      c.restore();
      c.globalAlpha = 1; c.fillStyle = css(el, names[i]); c.fillRect(cx - 3, y - 12 + bob, 6, 6);
    });
  });
  /* transfer, CAD register: three pack silhouettes as line drawings, each with its 11 × 18 footprint;
     the panel translates between footprints and docks exactly. Mono readouts, registration marks. */
  document.querySelectorAll('[data-h2-transfer]').forEach(cv => {
    const el = cv.closest('.rr'); const labels = cv.closest('[data-h2-transfer-wrap]')?.querySelectorAll('[data-h2-label]');
    const mono = () => (css(el, '--rr-mono') || 'monospace');
    // pack silhouettes in a 100-wide unit box, drawn around a footprint of 11 × 18 (w × h) units × k
    function pack(c, kind, x, y, w, h, ink) {
      c.strokeStyle = ink; c.lineWidth = 1; c.lineJoin = 'miter'; c.globalAlpha = .6; c.beginPath();
      const r = w * .06;
      if (kind === 0) { // roll-top: tall body, rolled collar, side buckle
        c.moveTo(x + r, y + h * .16); c.lineTo(x + w - r, y + h * .16); c.lineTo(x + w, y + h * .16 + r); c.lineTo(x + w, y + h - r); c.quadraticCurveTo(x + w, y + h, x + w - r, y + h); c.lineTo(x + r, y + h); c.quadraticCurveTo(x, y + h, x, y + h - r); c.lineTo(x, y + h * .16 + r); c.closePath(); c.stroke();
        c.beginPath(); c.roundRect(x - w * .02, y + h * .06, w * 1.04, h * .1, h * .05); c.stroke();
        c.beginPath(); c.moveTo(x + w * .5, y); c.lineTo(x + w * .5, y + h * .06); c.stroke();
        c.beginPath(); c.moveTo(x + w * .18, y + h * .3); c.lineTo(x + w * .18, y + h * .92); c.moveTo(x + w * .82, y + h * .3); c.lineTo(x + w * .82, y + h * .92); c.stroke();
      } else if (kind === 1) { // top-loader: lid flap, horizontal zip, twin straps
        c.moveTo(x, y + h * .12); c.lineTo(x + w, y + h * .12); c.lineTo(x + w, y + h - r); c.quadraticCurveTo(x + w, y + h, x + w - r, y + h); c.lineTo(x + r, y + h); c.quadraticCurveTo(x, y + h, x, y + h - r); c.closePath(); c.stroke();
        c.beginPath(); c.moveTo(x + w * .06, y + h * .12); c.lineTo(x + w * .1, y); c.lineTo(x + w * .9, y); c.lineTo(x + w * .94, y + h * .12); c.stroke();
        c.setLineDash([3, 3]); c.beginPath(); c.moveTo(x + w * .08, y + h * .3); c.lineTo(x + w * .92, y + h * .3); c.stroke(); c.setLineDash([]);
        c.beginPath(); c.moveTo(x + w * .3, y + h * .3); c.lineTo(x + w * .3, y + h * .96); c.moveTo(x + w * .7, y + h * .3); c.lineTo(x + w * .7, y + h * .96); c.stroke();
      } else { // panel-loader: wide body, U zip around the front panel, grab handle
        c.moveTo(x + r, y + h * .1); c.lineTo(x + w - r, y + h * .1); c.quadraticCurveTo(x + w, y + h * .1, x + w, y + h * .1 + r); c.lineTo(x + w, y + h - r); c.quadraticCurveTo(x + w, y + h, x + w - r, y + h); c.lineTo(x + r, y + h); c.quadraticCurveTo(x, y + h, x, y + h - r); c.lineTo(x, y + h * .1 + r); c.quadraticCurveTo(x, y + h * .1, x + r, y + h * .1); c.closePath(); c.stroke();
        c.setLineDash([3, 3]); c.beginPath(); c.moveTo(x + w * .1, y + h * .1); c.lineTo(x + w * .1, y + h * .82); c.quadraticCurveTo(x + w * .1, y + h * .9, x + w * .18, y + h * .9); c.lineTo(x + w * .82, y + h * .9); c.quadraticCurveTo(x + w * .9, y + h * .9, x + w * .9, y + h * .82); c.lineTo(x + w * .9, y + h * .1); c.stroke(); c.setLineDash([]);
        c.beginPath(); c.moveTo(x + w * .38, y + h * .1); c.quadraticCurveTo(x + w * .38, y, x + w * .5, y); c.quadraticCurveTo(x + w * .62, y, x + w * .62, y + h * .1); c.stroke();
      }
      c.globalAlpha = 1;
    }
    function tick(c, x1, y1, x2, y2, ink) { c.strokeStyle = ink; c.lineWidth = 1; c.globalAlpha = .55; c.beginPath(); c.moveTo(x1, y1); c.lineTo(x2, y2); c.stroke(); c.globalAlpha = 1; }
    run(cv, (c, W, H, t) => {
      const fg = css(el, '--rr-fg'), mute = css(el, '--rr-mute'), bg = css(el, '--rr-bg'), acid = css(el, '--rr-core');
      const small = W < 700, fs = small ? 9 : 10.5;
      c.font = `${fs}px ${mono()}`; c.textBaseline = 'alphabetic';
      // registration marks
      const m = small ? 10 : 16, L = small ? 8 : 12;
      [[m, m], [W - m, m], [m, H - m], [W - m, H - m]].forEach(([x, y]) => { tick(c, x - L, y, x + L, y, mute); tick(c, x, y - L, x, y + L, mute); });
      c.fillStyle = mute; c.globalAlpha = .9; c.textAlign = 'left'; c.fillText('PANEL TRANSFER · RR-CORE-01', m + L + 8, m + 4); c.textAlign = 'right'; c.fillText('FOOTPRINT 11 × 18 IN', W - m - L - 8, m + 4); c.globalAlpha = 1;
      // layout: three footprints, same size (the panel is the constant), packs sized by volume
      const fh = Math.min(H * .5, (W / 3) * .62), fw = fh * 11 / 18, baseY = H * .8;
      const vol = [.86, 1, 1.14], xs = [W * .2, W * .5, W * .8];
      const foots = xs.map((x, i) => { const ph = fh * [1.36, 1.38, 1.44][i], pw = fw * [1.4, 1.55, 1.95][i]; return { x, px: x - pw / 2, py: baseY - ph, pw, ph, fx: x - fw / 2, fy: baseY - ph * .07 - fh }; });
      // sequence: dwell, then travel; loop 0→1→2→1
      const seq = [0, 1, 2, 1], period = 2600, T = reduced ? 1.5 * period : (t % (period * seq.length)), k = Math.floor(T / period), u = (T % period) / period;
      const a = seq[k], b = seq[(k + 1) % seq.length], e = u < .62 ? 0 : (u - .62) / .38, ease = e * e * (3 - 2 * e), docked = e === 0 || e >= 1;
      const cur = e > .5 ? b : a;
      foots.forEach((f, i) => {
        pack(c, i, f.px, f.py, f.pw, f.ph, i === cur ? fg : mute);
        // footprint: dashed 11 × 18 rectangle inside each pack
        c.strokeStyle = i === cur ? acid : mute; c.globalAlpha = i === cur && docked ? .9 : .45; c.setLineDash([4, 4]); c.lineWidth = 1; c.strokeRect(f.fx, f.fy, fw, fh); c.setLineDash([]); c.globalAlpha = 1;
        // dimension line under the pack with ticks
        const dy = baseY + (small ? 12 : 18);
        tick(c, f.px, dy - 4, f.px, dy + 4, mute); tick(c, f.px + f.pw, dy - 4, f.px + f.pw, dy + 4, mute); tick(c, f.px, dy, f.px + f.pw, dy, mute);
      });
      // the panel: chamfered plate with five module bars, translating between footprints
      const fa = foots[a], fb = foots[b], px = fa.fx + (fb.fx - fa.fx) * ease, lift = Math.sin(ease * Math.PI) * fh * .28, py = fa.fy + (fb.fy - fa.fy) * ease - lift;
      const ch = fw * .13;
      c.fillStyle = bg; c.globalAlpha = .96; c.beginPath(); c.moveTo(px, py); c.lineTo(px + fw - ch, py); c.lineTo(px + fw, py + ch); c.lineTo(px + fw, py + fh); c.lineTo(px, py + fh); c.closePath(); c.fill();
      c.globalAlpha = 1; c.strokeStyle = fg; c.lineWidth = 1.3; c.stroke();
      // slot grid (faint) and module bars
      c.strokeStyle = fg; c.globalAlpha = .18; c.lineWidth = 1; for (let r = 1; r < 9; r++) { const y = py + fh * r / 9; c.beginPath(); c.moveTo(px + fw * .08, y); c.lineTo(px + fw * .92, y); c.stroke(); } c.globalAlpha = 1;
      for (let i = 0; i < 5; i++) { c.fillStyle = css(el, MODS[i]); c.globalAlpha = .9; c.fillRect(px + fw * .12, py + fh * (.07 + i * .18), fw * .76, fh * .13); } c.globalAlpha = 1;
      // readout under the docked footprint
      if (docked) { const f = foots[cur]; c.fillStyle = acid; c.textAlign = 'center'; c.fillText('FIT · EXACT', f.x, f.fy - 8); }
      else if (py - 8 > m + fs + 14) { c.fillStyle = mute; c.textAlign = 'center'; c.fillText('TRANSFER', px + fw / 2, py - 8); }
      if (labels) labels.forEach((l, i) => l.classList.toggle('on', i === cur));
    });
  });
})();

/* Feature clips: nothing downloads until the clip is on screen; play in view, pause out of view. */
(function () {
  const vids = document.querySelectorAll('video.rr-inview-video');
  if (!vids.length || !('IntersectionObserver' in window)) return;
  const io = new IntersectionObserver(es => es.forEach(e => {
    const v = e.target;
    if (e.isIntersecting) { if (v.preload === 'none') v.preload = 'auto'; v.play().catch(() => {}); }
    else v.pause();
  }), { rootMargin: '120px 0px' });
  vids.forEach(v => io.observe(v));
})();
